export const productImageFallback = `${process.env.BASE_URL || '/'}m_s_logo.svg`;

export function handleProductImageError(event) {
  const image = event.target;
  if (image && image.getAttribute('src') !== productImageFallback) {
    image.src = productImageFallback;
  }
}
